import { render, staticRenderFns } from "./eye-color.vue?vue&type=template&id=7a23b9b2&scoped=true"
import script from "./eye-color.vue?vue&type=script&lang=ts"
export * from "./eye-color.vue?vue&type=script&lang=ts"
import style0 from "./eye-color.vue?vue&type=style&index=0&id=7a23b9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23b9b2",
  null
  
)

export default component.exports